<template>
  <div class="tag">
    <div class="tag-operate">
      <el-button type="primary" icon="el-icon-plus" @click="append()">新增根标签</el-button>
    </div>
    <el-tree :data="data4" node-key="id" default-expand-all :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <el-input size="mini" v-if="data.editable" v-model="data.temp"></el-input>
        <span v-else>{{ node.label }}</span>
        <span>
          <template v-if="data.editable">
            <el-button type="text" size="mini" @click="() => save(node, data)">保存</el-button>
            <el-button type="text" size="mini" @click="() => cancel(node, data)">取消</el-button>
          </template>
          <template v-else>
            <el-button v-if="node.level < 4" type="text" size="mini" @click="() => append(data)">新增</el-button>
            <el-button type="text" size="mini" @click="() => edit(data)">编辑</el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
          </template>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: 'c-tag-level',
  props: {
    type: {
      type: String,
      required: true,
      default () {
        return 'publish'
      }
    }
  },
  data () {
    const data = [{
      id: 1,
      label: '一级 1',
      children: [{
        id: 4,
        label: '二级 1-1',
        children: [{
          id: 9,
          label: '三级 1-1-1'
        }, {
          id: 10,
          label: '三级 1-1-2'
        }]
      }]
    }, {
      id: 2,
      label: '一级 2',
      children: [{
        id: 5,
        label: '二级 2-1'
      }, {
        id: 6,
        label: '二级 2-2'
      }]
    }, {
      id: 3,
      label: '一级 3',
      children: [{
        id: 7,
        label: '二级 3-1'
      }, {
        id: 8,
        label: '二级 3-2'
      }]
    }]
    return {
      data4: JSON.parse(JSON.stringify(data))
    }
  },
  created () {
    this.$http.post('/tag/get', {
      type: this.type
    }).then(res => {
      this.data4 = res.data.data
    })
  },
  methods: {
    append (data) {
      const newChild = { id: `new-${new Date().getTime()}`, label: '', children: [], editable: true, temp: '' }
      if (data) {
        if (!data.children) {
          this.$set(data, 'children', [])
        }
        data.children.push(newChild)
      } else {
        this.data4.push(newChild)
      }
    },
    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      this.$_confirm({
        name: data.label,
        operate: () =>
          this.$http.post('/tag/delete', {
            id: data.id,
            type: this.type
          }),
        callback () {
          const index = children.findIndex(d => d.id === data.id)
          children.splice(index, 1)
        }
      })
    },
    edit (data) {
      this.$set(data, 'editable', true)
      this.$set(data, 'temp', data.label)
    },
    cancel (node, data) {
      data.editable = false
      if (data.label === '') {
        const parent = node.parent
        const children = parent.data.children || parent.data
        children.splice(children.findIndex(d => d.id === data.id), 1)
      }
    },
    save (node, data) {
      if (data.temp) {
        this.$http.post('/tag/add', {
          type: this.type,
          parentId: Array.isArray(node.parent.data) ? undefined : node.parent.data.id,
          id: `${data.id}`.indexOf('new') > -1 ? undefined : data.id,
          label: data.temp
        }).then(res => {
          data.id = res.id
        })
        data.label = data.temp
        data.editable = false
      } else {
        this.$message.error('请输入标签文本')
      }
    }
  }
}
</script>

<style lang="scss">
.tag {
  padding: 20px;
  background: #fff;
  max-width: 450px;
  .tag-operate{
    text-align: right;
    > .el-button {
      margin-bottom: 20px;
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-input {
    width: 200px;
    .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
  }
}
</style>
